<template>
    <div class="new_index newcontrain" style="padding-top: 95px;">
        <div class="typelist" style=" padding: 0 20px 0;height:auto" v-for="item in catlist">
            <span>{{item.name}}:</span>
            <a :class="[pageData.ClassCategoryId == 0? 'cur':'']" data-id="0" @click="chooseCat(0)">全部</a>
            <a :class="[pageData.ClassCategoryId == citem.id? 'cur':'']" @click="chooseCat(citem.id)"  v-for="citem in childCatlist" v-if="citem.fatherId== item.id">{{citem.name}}</a>
        </div>
        
        <div class="search">
            <div class="h-search">
                <input placeholder="输入要查找的内容" class="keyword" v-model="pageData.Name" @keyup="getlist()">
                <img src="images/top3.png" class="btn_search">
                <div></div>
            </div>
        </div>
        <div class="banlist">
            <div class="ban_item ban_item2" v-for="item in classList" @click="clickClassUrl(item)"> 
                <a>     
                    <img :src="item.logo" class="banlogo">         
                    <div class="rt">             
                        <div class="title" :title="item.name">{{item.name}}</div>             
                        <div class="info1">                 
                            <span class="txt" :title="item.summary">{{item.summary}}</span>             
                        </div>               
                        <div class="span1"><img src="images/icon-scale.png">  <span> {{item.scale}} </span> </div>  
                        <div class="span3"> <img src="images/icon-type.png"><span> {{item.category}}</span></div>                         
                        <div class="span2"><img src="images/icon-timelong.png"><span> {{item.startTime | dateFormat("YYYY.MM.DD")}}-{{item.endTime | dateFormat("MM.DD")}}</span></div>              
                    </div>   
                </a>            
            </div>
        </div>
        <div class="pagers">
            <el-pagination
            :current-page.sync="pageData.currentPage"
            :page-size.sync="pageData.pageSize"
            
            :total="pageData.total"
            v-bind="$attrs"
            @current-change="handleCurrentChange"
          />
        </div>
    </div>
</template>
  
  <script>
  import comFun from "@/common/common";
  import '@/plugins/element.js'
  export default {
    name: "",
    components: {},
    mounted() {
        this.getcats()
        this.getlist()
    },
    filters: {
       dateFormat(dateStr, pattern = '') {
        var dt = new Date(dateStr)
        var yy = dt.getFullYear()
        var mm = (dt.getMonth() + 1).toString().padStart(2, '0')
        var dd = dt.getDate().toString().padStart(2, '0')
        var h = dt.getHours().toString().padStart(2, '0')
        var m = dt.getMinutes().toString().padStart(2, '0')
        var s = dt.getSeconds().toString().padStart(2, '0')
        if (pattern.toLowerCase() === 'yyyy-mm-dd') {
            return yy + '-' + mm + '-' + dd
        } else if (pattern.toLowerCase() === 'yyyy.mm.dd') {
            return yy + '.' + mm + '.' + dd
        }  else if (pattern.toLowerCase() === 'mm.dd') {
            return  mm + '.' + dd
        } else if(pattern.toLowerCase() === 'yyyy-mm-dd hh:mm'){
            return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m 
        } else if(pattern.toLowerCase() === 'hh:mm'){
            return  h + ':' + m 
        }else {
            return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m + ':' + s
        }
      }
    },
    data() {
      return {
          catlist:[],
          childCatlist:[],
          pageData:{
                currentPage:1,
                pageSize:10,
                total:0,
                Name:"",
                ClassCategoryId:0
            },
          classList:[]
      };
    },
    methods: {
       async getcats(){
            this.catlist = await comFun.getCateGoriesList()
            this.childCatlist = await comFun.getChildCateGoriesList()
        },
        getlist() {
            var postdata =  {
                PageIndex:this.pageData.currentPage-1,
                ClassCategoryId:[],
                Name:this.pageData.Name,
                MaxResultCount:this.pageData.pageSize,
                SkipCount:this.pageData.pageSize*(this.pageData.currentPage-1),
            }
           if(this.pageData.ClassCategoryId > 0) postdata.ClassCategoryId.push(this.pageData.ClassCategoryId) 
           else postdata.ClassCategoryId = ''
            comFun.getclassList(postdata).then(res=>{
                this.pageData.total = res.totalCount
                this.classList = res.items
            })
        },
        handleCurrentChange(){
            this.getlist()
        },
        chooseCat (id){
            this.pageData.ClassCategoryId = id
            this.getlist()
        },
        clickClassUrl(item){
            // console.log(item)
            this.$router.push({
            name: 'ClassDetail',
            query: {
            id: item.id
            }})
        }

    }
  };
  </script>
  
  <style scoped>
  
  </style>
  